
const dateUtil = require('../dateUtil/dateUtil');
const businessHourOverridesUtil = require('../domain/businessHourOverridesUtil');
const openingHoursUtil = require('../domain/openingHoursUtil');

export function isStoreClosed(businessHourOverrides, openingHours, dispatchType)
{
    const currentUTCDateTime = dateUtil.getNow();
    const currentLocalDateTime = dateUtil.convertToLocalStandard(currentUTCDateTime);

    if (businessHourOverrides.length > 0)
    {
        //If store is setup as closed for these hour, store is closed
        if (businessHourOverridesUtil.isClosed(businessHourOverrides, currentUTCDateTime, dispatchType))
            return true;
        //If store is setup as open for these hours, store is NOT closed
        if (businessHourOverridesUtil.isOpen(businessHourOverrides, currentUTCDateTime, dispatchType))
            return false;
    }

    //If opening hours are setup and store is not open as per hours, store is closed
    if (openingHours.length > 0 && !openingHoursUtil.isOpen(openingHours, currentLocalDateTime, dispatchType))
        return true;

    //If none of the conditions is satisfied, store is not closed
    return false
}